//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useState, useCallback, useMemo, useEffect, memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import styled from "styled-components";
import moment from "moment";
import { Snackbar } from '@mui/material';

import { Alert } from '@mui/material';
import { find, flatMap, map, get, has } from "lodash";
//  -- Components ---------------------
import { Button, Modal } from '@mui/material';
import { Check, WatchLater, ArrowRight , Close } from '@mui/icons-material';
import { Accordion as MuiAccordion, AccordionSummary as MuiAccordionSummary, AccordionDetails as MuiAccordionDetails } from '@mui/material';
import { Typography } from '@mui/material';
//  -- Constants ----------------------
import COLOR from "utils/constants/color";

//  -- Lib ----------------------------
import { imageFetch, structureFetch, imageFetchFromPodcast, getExceptionStatus, getStatusByCode, isVideo , getStoryUrl , generateUrlForNonEbook, getEbookAssignmentDeepLinkUrl, getNonAssignableMaskId, subMissionViewTBG, shouldSkipLateDateForDiffStudent, getAssignmentNavigationUrl } from "utils/lib/ebookHelper";

//  -- Thunks -------------------------
import { handleCreatePastSubmission } from 'store/pastSubmission/thunks';
import { TootipWrapper } from "components/TooltipWrapper";
import GradeDisplay from 'components/GradeDisplay';
import RetakeModal from "components/RetakeModal";
import { BookSynoname } from 'utils/config/reference';
import { useResources } from "store/resources/selectors";
import { useOrgTimezone } from 'store/organizations/selectors';
import { useServertime } from 'store/servertime/selectors';
import { checkIsManualGradable, isAfterTime, isBeforTime, isGradedByTeacher } from "utils/methods/math"
import { useBookUnits } from 'store/booksUnits/selectors';
import { useStory } from "store/story/selectors";
import "moment-timezone"
import { useSocket } from "store/chat/selectors";

import { BACK_TO_BOOK } from 'utils/config/reference';
import { useExams } from "store/exams/selectors";
import { lighten } from "polished";
import { isDisabledForMe } from "utils/methods/validateData";
import { Tooltip } from "antd";
import * as Sentry from '@sentry/react';
import { handleListQuestionOfWorksheet } from "store/worksheet/thunks";
import { handleSubmitWorksheetAssignment } from "store/activities/thunks";
import { handleListUserSubmissionsByClass } from "store/submissions/thunks";
import dayjs from "utils/dayjsConfig";
import SpinLoader from "./Loader/SpinLoader";
import { NoteMark } from "./UI";
import { useAlert } from "./UI/alertSakeBar/alertProvider";
import { useApExams } from "store/apexams/selectors";
import { modifyUrlParams } from "modules/assignments/helper";
import { useAssignmentCoverTitle } from "./hooks/pageCover/useAssignmentCoverTitle";
import { getCoverForAssignment, isWaitingForAiGradingRestriction, normalizeWorksheetQuestions } from "utils/methods/functions";
import closeIconSvg from "../utils/assets/images/close-icon.svg";
import rightTickSvg from "../utils/assets/images/right-tick.svg";
import CountdownTimer from 'components/CountdownTimer';
import { useCurrentClass } from "store/classes/selectors";
import { useUserClasses } from "store/userClasses/selectors";
import { useUserProfileConfig } from "store/users/selectors";
import { usePageCover } from "./hooks/pageCover/pageCover";
import { updateUI } from "store/UI/actions";
import usePopUpAtOnce from "./hooks/usePopUpAtOnce";
import useNotification from "./hooks/notification/useNotification";
import { useAudioPermissionCheck } from "./hooks/useAudioPermission/useAudioPermissionCheck";
import MicrophonePermissionModal from "./UI/modal/MicrophonePermissionModal";
import SentryWrap from 'components/Sentry';
import useIsExamActive from "./hooks/books/useIsExamActive";
import useCheckAudioAndWritten from "./UI/scoreMessage/useCheckAudioAndWritten";
import { setWorksheetView } from "store/worksheetView/action";
import { useClassGameActivity } from "store/one_game/selectors";


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Actions = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width:500px) {
    position: unset;
  }
`;

const Responce = styled.button`
  display: flex;
  flex-direction: column;
  right: 14px;
  bottom: 16px;
  border-radius: 15px;
  border-width: 0px;
  min-height: 32px;
  padding-left: 15px;
  padding-right: 15px;
  justify-content: center;
  color: ${COLOR.white};
  width: 150px;
  align-items: center;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  font-weight: 700;
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};
  background: linear-gradient(270deg, #9958EE 0.06%, #505FFE 99.93%);
  @media (max-width: 767px) {
    padding-left: 5px;
    padding-right: 5px;
    width: 128px;
  }
`;
const CompleteText = styled.span`
  align-items: center;
  color: ${p => p.deactivate ? COLOR.redishpink : COLOR.green100};
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: 600;
`;
const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  max-width: 85%;
  @media (min-width: 768px) and (max-width: 960px) {
     max-width: 80%;
     width: 80%;
  }
  @media (max-width: 767px){
     max-width: 80%;
     width: 80%;
  }
`;

const Header = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 16px;
  word-break: break-all;
  position: relative;
  gap: 12px;
`;

const Image = styled.img`
  border: 1px solid ${COLOR.black800};
  width: 100%;
  height: auto;
`;

const ImageContiner = styled.button`
  background-color: transparent;
  border: none;
  cursor: zoom-in;
  flex: 1;
  max-width: 154px;
  outline: none;
  padding-right: 24px;
  margin-bottom: 22px;
  @media (max-width: 599px) {
    max-width: 85px;
    padding-right: 20px;
  }
`;

const ImageModal = styled.div`
  left: 50%;
  max-width: 544px;
  padding: 0px 24px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
`;

const TextContainer = styled.div`
  justify-content: flex-end;
  position: relative
`;

const Text = styled.div`
  font-size: 12px;
  font-weight: 300;
  line-height: 20px;
`;

const Wrapper = styled.div`
  align-items: flex-start;
  display: flex;
  width: 100%;
  height: auto;
  padding: 26px;
  border-bottom: 1px solid #D3D3D3;
  position: relative;
`;

const OuterWrapper = styled.div`
`
const AccordianTitle = styled(Typography)`
    display:flex;
    flex-direction:row;
    align-items: center;
    gap: 20px;
    width:100%;
`
const Rotate = styled.div`
    align-items: center;
    display: flex;
    height: 16px;
    justify-content: center;
    margin-right: 4px;
    transform: ${p => p.open ? 'rotate(90deg)' : 'rotate(0deg)'};
    transition: all 300ms ease;
    width: 16px;
`;
const Notification = styled.div`
    background-color: ${p => p.bgColor ? p.bgColor : lighten(0.45, '#3D5F8F')};
    border: 1px dashed ${p => p.bgColor ? p.color : '#3D5F8F'};
    border-radius: 3px;
    color: ${p => p.color ? p.color : '#3D5F8F'};
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 24px;
    padding: 8px;
`;

const ExamHeader = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;

const ExamBadge = styled.span`
    background: ${p => p.color ? p.color : 'linear-gradient(135deg, #FF6B6B 0%, #EE5A6F 100%)'};
    border-radius: 12px;
    color: ${p => p.textColor ? p.textColor : COLOR.white};
    font-size: 11px;
    font-weight: 700;
    padding: 4px 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 4px rgba(238, 90, 111, 0.3);
    @media (max-width: 767px) {
        font-size: 10px;
        padding: 3px 8px;
    }
`;

// ✅ Accordion
const Accordion = styled(MuiAccordion)(({ theme }) => ({
  border: '1px solid white',
  boxShadow: 'none',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 'auto',
  },
}));

// ✅ AccordionSummary
const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  backgroundColor: '#03989e',
  color: 'white',
  textTransform: 'capitalize',
  borderBottom: '1px solid white',
  marginBottom: -1,
  minHeight: 47,
  height: 47,
  '&.Mui-expanded': {
    minHeight: 47,
  },
  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: '8px 0',
  },
}));

// ✅ AccordionDetails
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: '2px',
  display: 'flex',
  flexDirection: 'column',
}));

  
const CurrentSubmission = {
  backgroundColor: '#9933ff'
}

const StatusBadge = ({ status }) => {
  if (!status) return null;

  const statusConfig = {
    Missing: { color: '#e74c3c', label: 'Missing' },
    Incomplete: { color: '#e67e22', label: 'Incomplete' },
    Excused: { color: '#27ae60', label: 'Excused' },
  };

  const config = statusConfig[status];

  if (!config) return <>{status}</>;

  return <span style={{ color: config.color }}>{config.label}</span>;
};

const FeedbackLink = styled.div`
  border: 1px solid rgb(251, 251, 251);
  border-radius: 10px;
  padding: 4px 10px;
  color: #ffffff;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  margin-right: auto;
  font-size: 12px;
  font-weight: 800;
  transition: color 0.2s ease;
  opacity: ${props => props.disabled ? '0.5' : '1'};
`;
//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------

const AssignmentStatus = ({
  chapter,
  data,
  submission,
  booksAllList,
  currentUser,
  showResponce,
  book,
  onShowResponce,
  assignment
}) => {
  const showAlert = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const servertime = useServertime()
  const timezone = useOrgTimezone()
  const story = useStory();
  const apExams = useApExams();
  const bookUnits = useBookUnits();
  const { socketConnection, reCreateSocket } = useSocket();
  const currentClass = useCurrentClass();
  const userClasses = useUserClasses();
  const { class_game_activity } = useClassGameActivity();

  // State declarations
  const [modalOpen, setModalState] = useState(false);
  const [isRetakeOpen, setisRetakeOpen] = useState(false);
  const [responsesModalOpen, setResponsesModalOpen] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [loadingQuestions, setloadingQuestions] = useState(false);
  const [openReviewDialog, setReviewDialog] = React.useState(false);
  const [showCountdownTimer, setShowCountdownTimer] = useState(false);
  const [timerExpired, setTimerExpired] = useState(false);
  const { isAiPermissionEnabled } = useUserProfileConfig();
  // Effects
  useEffect(() => {
    if (responsesModalOpen && submission?.id) {
      setExpanded(submission.id);
    }
  }, [responsesModalOpen, submission]);

  useEffect(() => {
    if (responsesModalOpen) {
      setExpanded('current');
    }
  }, [responsesModalOpen]);

  useEffect(() => {
    if (responsesModalOpen) {
      const y = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${y}px`;
    } else {
      const y = -parseInt(document.body.style.top || '0');
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, y);
    }
  }, [responsesModalOpen]);

  useEffect(() => {
    if (submission?.assignmentId && currentUser?.role === 'student') {
      const finishLaterClicked = localStorage.getItem(`finishLater_${submission?.assignmentId}`);
      if (finishLaterClicked === 'true' && (!submission || !submission.complete)) {
        setShowCountdownTimer(true);
      } else {
        setShowCountdownTimer(false);
      }
    }
  }, [submission?.assignmentId, currentUser?.role, submission?.complete, submission]);
  

  const pastSubmissions = useMemo(() => {
    if (!submission || !submission.pastSubmissions) return [];
    const returnedAtNumbers = Array.isArray(submission.returned_at)
      ? submission.returned_at.map(num => parseInt(num)-1)
      : [];
    const grouped = submission.pastSubmissions.reduce((acc, sub) => {
      const submissionNum = parseInt(sub.submissions);
      if (!acc[submissionNum]) {
        acc[submissionNum] = [];
      }
      acc[submissionNum].push(sub);
      return acc;
    }, {});

    const filtered = Object.values(grouped).flatMap((group) => {
      const hasNonEmptyAnswers = group.some(sub => Array.isArray(sub.answers) && sub.answers.length > 0);
      if (hasNonEmptyAnswers && !returnedAtNumbers.includes(parseInt(group[0].submissions))) {
        return group.filter(sub => Array.isArray(sub.answers) && sub.answers.length > 0);
      }
      return group;
    });
    const sorted = filtered.sort((a, b) => parseInt(a.submissions) - parseInt(b.submissions));
    return sorted;
  }, [submission]);

  useEffect(() => {
    if ((!pastSubmissions || pastSubmissions.length === 0) && expanded !== 'current') {
      setExpanded('current');
    }
  }, [pastSubmissions]);

  const isAssignmentTakable = useCallback(() => {
    const skipLateDate = shouldSkipLateDateForDiffStudent(data, currentUser, currentClass);
    
    if (get(data, "lateDate") == "always") {
      return true;
    } 
    else if (get(data, "lateDate") && !skipLateDate) {
      if (isAfterTime(get(data, "lateDate"), servertime, timezone)) {
        return true;
      } else if (isAfterTime(get(data, "dueDate"), servertime, timezone)) {
        return true;
      }
    }else{
      if (isAfterTime(get(data, "dueDate"), servertime, timezone)) {
        return true;
      }
      return false;
    }
  }, [servertime, data, currentUser, currentClass]); 
  const resources = useResources()
  const ungraded = get(data, "ungraded", false)
  const grade_type = get(data,"grade_type");
  const isCompleteInComplete = grade_type === "complete_incomplete"
  const max_point = data?.max_point && !isNaN(data?.max_point) ? Number.parseInt(data.max_point, 10) : 100
  const isPointSystem =  grade_type === "points"
  const is_game = submission?.assignmentType === "game" || submission?.type === "game" || data?.type === "game" || false;
  const is_debate = submission?.assignmentType === "debate" || submission?.type === "debate" ;
  const is_worksheet = submission?.assignmentType === "worksheet" || submission?.type === "worksheet" ;
  const coverTitle = useAssignmentCoverTitle({
    assignment: { ...data, assignmentType: submission?.assignmentType, type: submission?.type }
  });
  const is_loteria = submission?.assignmentType === "bingo" || submission?.type === "bingo";
  const is_data_debate = data?.type === "debate" || false;
  const is_data_loteria = data?.type === "bingo" || false;
  const is_data_worksheet = data?.type === "worksheet" || false;

  const canViewResponses = useMemo(() => {
    if (!submission || !submission.id) return false;
    if (is_worksheet || is_data_worksheet) return true;
    if (pastSubmissions.length > 0) return true;
    return parseInt(submission.submissions, 10) > 0;
  }, [submission, pastSubmissions, is_worksheet, is_data_worksheet]);

  const retakeAvailable = submission
    ? submission?.exceptionStatus ==3?true: parseInt(submission?.submissions, 10) < parseInt(data?.retakes, 10) + 1
    : true;
  const { isException, exceptionStatusText } = getExceptionStatus(submission,currentUser);
  const hasDuration = !isNaN(parseInt(data?.timeDuration)) && data?.timeDuration > 0;
    const deactive_for_me =  useMemo(()=>isDisabledForMe(data,currentUser.id),[data,currentUser])
  const isActive = get(data, "active", true) && !deactive_for_me;;
  const deactivateStudent = data?.deactivated_student?.includes(currentUser?.id);
  const view_result = useMemo(() => {
    const result_visibility_on = data?.result_visibility_on;
    return result_visibility_on ? isBeforTime(result_visibility_on, servertime, timezone) : true;
  }, [data?.result_visibility_on, servertime, timezone]);

  const {checkAllTypeExamBook} = useIsExamActive();
  const {isAudioAndWritten, isCheckAudiOrWritten} = useCheckAudioAndWritten({ questions: data?.data?.questions });
  const { readSingleNotification } = useNotification();
  const exams = useExams();

  const resourcesVideos = useMemo(
    () => flatMap(map(resources, (resource) => resource.videos)),
    [resources]
  );

  const checkBookAssignableOrNotAssignable = useMemo(
    () => booksAllList?.find((book) => Number(book.id) === Number(data?.data?.bookId)) || {},
    [booksAllList, data?.data?.bookId]
  );

  const storyBook = useMemo(
    () => find(story, ["bookId", data?.data?.bookId]) || {},
    [story, data?.data?.bookId]
  );

  const isStoryBook = useMemo(
    () => Object.keys(storyBook).length > 0,
    [storyBook]
  );

  const isApExams = useMemo(
    () => Boolean(find(apExams, (entry) => find(entry.exams, (exam) => exam.bookId == data?.data?.bookId))),
    [apExams, data?.data?.bookId]
  );

  const examBookIdSet = useMemo(() => {
    const ids = new Set();
    exams?.forEach((entry) => {
      entry.exams?.forEach((exam) => {
        if (exam?.bookId != null) {
          ids.add(`${exam.bookId}`);
        }
      });
    });
    return ids;
  }, [exams]);

  const isExamBook = useMemo(
    () => examBookIdSet.has(`${data?.data?.bookId}`),
    [examBookIdSet, data?.data?.bookId]
  );

  const classExamHiddenMeta = useMemo(() => {
    const classInfo = find(userClasses, ["id", currentClass?.id]);
    return classInfo?.config?.meta_data || {};
  }, [userClasses, currentClass?.id]);

  const isExamHidden = useCallback((bookId) => {
    const fetchExams = exams?.find((entry) =>
      entry.exams?.some((exam) => `${exam.bookId}` === `${bookId}`)
    );
    if (!fetchExams) {
      return false;
    }
    const examLevel = fetchExams?.exam_school || "";
    if (classExamHiddenMeta.highSchool && examLevel === "high") {
      return true;
    }
    if (classExamHiddenMeta.middleSchool && examLevel === "middle") {
      return true;
    }
    return false;
  }, [exams, classExamHiddenMeta]);

  const pageDisplay = useMemo(() => {
    const numberMaskForNonAssignable =
      checkBookAssignableOrNotAssignable?.isNotAssignable &&
      !isExamBook &&
      !isStoryBook &&
      !isApExams;

    if (numberMaskForNonAssignable) {
      return {
        numberMasked: "",
        nonAssignAbleMaskId: getNonAssignableMaskId(bookUnits, data),
        numberMaskForNonAssignable: true,
      };
    }

    let _book = find(booksAllList, { id: chapter });
    let numberMasked = "";
    if (_book) {
      const numberMask = find(_book.pages, (pageItem) => pageItem.pageId == (data?.data?.page || data?.page));
      numberMasked = numberMask?.NumberMasked || (data?.data?.page || data?.page);
    } else {
      numberMasked = data?.data?.page || data?.page;
    }

    return {
      numberMasked,
      nonAssignAbleMaskId: "",
      numberMaskForNonAssignable: false,
    };
  }, [
    checkBookAssignableOrNotAssignable,
    isExamBook,
    isStoryBook,
    isApExams,
    bookUnits,
    data,
    booksAllList,
    chapter,
  ]);

  const { numberMasked, nonAssignAbleMaskId, numberMaskForNonAssignable } = pageDisplay;
  const { updatePopUpAtOnce } = usePopUpAtOnce();
  const { checkAudioQuestionsAndRequestPermission } = useAudioPermissionCheck();

  const fetchData = async (id) => {
    try {
      const has_q = questions.length>0
        setloadingQuestions(!has_q);
        const response = await dispatch(handleListQuestionOfWorksheet(id));
        const normalized = normalizeWorksheetQuestions(response);
        if (normalized.length > 0) {
            setQuestions(normalized);
        }else{
            setQuestions([]);
            showAlert("No questions found for this worksheet.", "warning");
        }
        
    } catch (error) {
        
    } finally{
        setloadingQuestions(false)
    }
  };

  useEffect(() => {
    if (!(is_worksheet || is_data_worksheet) || !responsesModalOpen) return;
    const worksheetId = assignment?.game_id ?? data?.game_id ?? data?.data?.id;
    if (worksheetId) fetchData(worksheetId);
  }, [responsesModalOpen, is_worksheet, is_data_worksheet, assignment?.game_id, data?.game_id, data?.data?.id]);

  const getNumberMask = useCallback((_page) => {
    const _book = find(booksAllList, { id: chapter });
    if (_book) {
      const numberMask = find(_book.pages, (pageItem) => pageItem.pageId == _page);
      return numberMask?.NumberMasked || _page;
    }
    return _page;
  }, [chapter, booksAllList]);
  const generateUrl = (CHAPTER_ID, page, activity, quiz,is_graphic_organizer) => {
    const storyUrl = getStoryUrl(story, CHAPTER_ID, page, quiz, activity)
    const backToLabel = BACK_TO_BOOK[CHAPTER_ID]
    const BALCON_PAGES = get(find(bookUnits, ["bookId", CHAPTER_ID]), "pages", [])
    const bookitem = find(BALCON_PAGES, k => parseInt(k.start) <= page && parseInt(k.finish) >= page)
    const url = generateUrlForNonEbook(bookitem?.id, page, activity, quiz, backToLabel, null, CHAPTER_ID,is_graphic_organizer)
    if (url && backToLabel) {
        return url;
    }
    else if (storyUrl) {
        return storyUrl;
    } else {
        return null;
    }
}

const assignmentInfoData = (worksheetInfo) => {
  if (
    worksheetInfo &&
    worksheetInfo.id &&
    Array.isArray(class_game_activity) &&
    class_game_activity.length > 0
  ) {
    const activity = class_game_activity.find(
      (k) => k.game_id == worksheetInfo.id && k.classId == currentClass.id
    );
    if (activity) return activity;
    return {};
  }
  return {};
};

const fetchCurrentSubmissionData = async (worksheetId, worksheetSubmission) => {
  try {
    if (!worksheetSubmission?.id) {
      const submitDataObj = {
        worksheet_id: worksheetId,
        answer: [],
        class_id: currentClass.id,
        student_id: currentUser.id,
        time_duration: 0,
        total_correct_answer: 0,
        total_wrong_answer: 0,
        finish_later: 0,
        complete: false,
        submissions: 0,
      };
      await dispatch(handleSubmitWorksheetAssignment(submitDataObj));
      dispatch(handleListUserSubmissionsByClass(currentUser?.id, currentClass?.id));
    }
  } catch (error) {
    Sentry.captureException(error);
  }
};

const graphicOrganizationRedirect = async (data) => {
  const url = getEbookAssignmentDeepLinkUrl(data);
  if(url?.includes('worksheet')){
    const worksheetId = data?.data?.id ?? data?.game_id;
    const hasSubmission =
      is_worksheet || is_data_worksheet
        ? submission
        : null;
    const assignmentInfo = assignmentInfoData(data?.data);
    const scheduleAt = assignmentInfo?.scheduleAt;
    const dueDate = assignmentInfo?.dueDate;
    const now = dayjs();
    const isWithinSchedule =
      scheduleAt && dueDate
        ? now.isAfter(dayjs(scheduleAt)) && now.isBefore(dayjs(dueDate))
        : true;
    const is_practice_mode =
      hasSubmission?.complete || !isWithinSchedule ? true : false;
    const response = await dispatch(
      handleListQuestionOfWorksheet(worksheetId)
    );
    if (!is_practice_mode) {
      await fetchCurrentSubmissionData(worksheetId, hasSubmission);
    }
    let questionArray = [];
    if (Array.isArray(response)) {
      response.forEach((element) => {
        if (!element?.id) return;
        element.question.id = element?.question_id;
        const questionData = {
          ...element?.question,
          image: element?.image,
          answer_audio: element?.answer_audio,
          question_audio: element?.question_audio,
        };
        questionArray.push(questionData);
      });
    }
    const isResuming =
      hasSubmission && hasSubmission.complete === false && !is_practice_mode;
    const resumeData = isResuming
      ? {
          activeIndex: hasSubmission.answers?.length || 0,
          studentSubmission: hasSubmission.answers || [],
          isCorrect:
            hasSubmission.answers?.filter((a) => a.isCorrect)?.length || 0,
        }
      : null;
    const isAssigned = !!assignmentInfo?.id;
    const isActiveSchedule = !isAssigned || isWithinSchedule;
    const for_grade = isActiveSchedule && !hasSubmission?.complete;
    const listData = {
      open: true,
      questions: questionArray,
      title: data?.data?.displayName,
      GetBookName: data?.data?.bookName,
      bookId: numberMasked || data?.bookId,
      assignmentInfo,
      for_grade,
      has_submission: is_practice_mode,
      resumeData,
    }
    await dispatch(setWorksheetView(listData));
  }
  if (url) {
    navigate(url);
    return true;
  }
  return false;
};
const findEngageData = useMemo(() => {
  try {
    const currentEngage = data?.data?.config_assignment?.engage_id;
    if (currentEngage) {
      const allEngage = checkBookAssignableOrNotAssignable?.engage;
      return find(allEngage, { id: currentEngage }) || null;
    }
    return null;
  } catch (error) {
    Sentry.captureException(error);
    return null;
  }
}, [data, checkBookAssignableOrNotAssignable]);
  const reditrectToAssignment = async () => {
    try {
      if (data?.data) {
        const hasAudioPermission = await checkAudioQuestionsAndRequestPermission(data.data);
        if (!hasAudioPermission) {
          return;
        }
      }
      const chapter = get(data, 'data.chapter', '');
      const assignmentId = get(data, 'data.id');
      const typeId = get(data, 'data.typeId', '');
      const is_graphic_organizer =
        get(data, 'data.type') === 'graphic_organizer' ||
        get(data, 'data.activity_type') === 'graphic_organizer';
      const assignmentPage = get(data, 'data.page', 0);
      const generatedUrl = generateUrl(
        chapter,
        assignmentPage,
        typeId.includes('activity') ? assignmentId : null,
        typeId.includes('quiz') ? assignmentId : null,
        is_graphic_organizer,
      );
      readSingleNotification(chapter,data?.data?.page,currentUser,data);
      if (data?.data?.config_assignment?.isFrom === 'engagement') {
        if (findEngageData && findEngageData?.imageData?.length > 0) {
          updatePopUpAtOnce(false);
          dispatch(updateUI({ openEngageModalTeacher: { open: true, data: findEngageData?.imageData } }));
        }
      }
      if (data?.assignfrom && data?.assignfrom?.urlPath) {
        if (data?.assignfrom?.urlPath?.includes('/video')) {
          navigate(getAssignmentNavigationUrl(`/video?id=${chapter}&quiz=${assignmentId}`, data));
          return;
        }
        const modifiedUrl = modifyUrlParams(data.assignfrom.urlPath, {
          activity: typeId === 'activity' ? assignmentId : null,
          quiz: typeId === 'quiz' ? assignmentId : null,
        });
        navigate(modifiedUrl);
        return;
      }
      if (isVideo(chapter, resources)) {
        navigate(getAssignmentNavigationUrl(`/video?id=${chapter}&quiz=${assignmentId}`, data));
      } else if (generatedUrl) {
        navigate(getAssignmentNavigationUrl(generatedUrl, data));
      } else {
        const graphic = await graphicOrganizationRedirect(data);
        if (!graphic) {
          navigate(
            `/ebook?chapter=${chapter}&page=${assignmentPage}&activity=${typeId.includes('activity') ? assignmentId : null}&quiz=${typeId.includes('quiz') ? assignmentId : null}`,
          );
        }
      }
    } catch (error) {
      Sentry.captureException(`202 Error in reditrectToAssignment: ${error}`);
      console.log(error, 'error');
    }
  };



  const onSubmit = async () => {
    if (!isActive || deactivateStudent) {
      return;
    }
    const assignmentId = data?.id ?? data?.data?.id;
    const shouldOpenStoryWidget = currentUser?.role === 'student' && (buttonText === "Start" || buttonText === "Retake");
    const shouldCheckExamAccess = buttonText === "Start" || buttonText === "Resume" || buttonText === "Retake";
    const examBookId = get(data, "data.chapter", "") || get(data, "data.bookId", "");
    if (shouldCheckExamAccess && isExamHidden(examBookId)) {
      showAlert('Your teacher has hidden this exam and you are no longer able to take it.', 'info');
      return;
    }
    if(checkAllTypeExamBook(data?.data?.chapter) && isAudioAndWritten && !submission?.id && data?.data?.questions?.length > 0){
      setTimeout(() => {
        dispatch(updateUI({ openScoreMessageModal: {open: true, category: data?.ai_grading_config?.grade_level, isCheckAudiOrWritten: isCheckAudiOrWritten(data?.data?.questions)} }));
      }, 1000);
    }
    if (submission?.complete && !retakeAvailable) {
      return;
    } else if (submission?.complete && retakeAvailable) {
      if (shouldOpenStoryWidget && assignmentId) {
        localStorage.setItem(`open_story_ai_${assignmentId}`, "true");
        localStorage.removeItem(`skip_story_ai_${assignmentId}`);
      }
      if (data?.id && currentUser?.role === 'student') {
        localStorage.removeItem(`finishLater_${data.id}`);
        setShowCountdownTimer(false);
      }
      await dispatch(handleCreatePastSubmission({  submissionId: submission?.id , is_missing: submission?.exceptionStatus ==3?true: false }))
      // await dispatch(
      //   handleUpdateSubmission(submission?.id, {
      //     ...submission,
      //     complete: false,
      //     retaking: true,
      //     answers: [],
      //     graded: false,
      //     feedback: "",
      //     audioFeedback: null,
      //     timmer: 0,
      //     ai_feedback:[]
      //   })
      // );
      reditrectToAssignment()
      // const notificationData = {
      //   classId: get(currentClass, 'id', ''),
      //   displayName: get(submission, 'assignment.displayName', ''),
      //   userId: get(currentUser, 'id', ''),
      //   modified: new Date(),
      //   data: {
      //     chapter: get(submission, 'assignment.chapter', ''),
      //     page: get(submission, 'assignment.page', ''),
      //     id: get(submission, 'assignment.id', ''),
      //   },
      //   message: `${get(currentUser, 'firstName', '')} ${get(currentUser, 'lastName', '')} Retake this Assignment`,
      //   createdBy: get(currentClass, 'teacherId', ''),
      //   type: 'update_activity',
      //   seen: true
      // }
      // sendNotifications(notificationData);
    } else {
      if (shouldOpenStoryWidget && assignmentId) {
        localStorage.setItem(`open_story_ai_${assignmentId}`, "true");
        localStorage.removeItem(`skip_story_ai_${assignmentId}`);
      }
      reditrectToAssignment()
    }
  };
  const handleClose = () => {
    setReviewDialog(false);
  };

  const scrollToTeacherFeedback = (event, hasFeedback) => {
    event.stopPropagation();
    
      if (!hasFeedback) {
        showAlert('No teacher feedback available for this submission.', 'info');
        return;
      }
    
    setTimeout(() => {
      const expandedAccordions = document.querySelectorAll('.accordianModal .MuiAccordion-root.Mui-expanded');
      
      expandedAccordions.forEach((accordion) => {
        const accordionDetails = accordion.querySelector('.MuiAccordionDetails-root');
        if (accordionDetails) {
          const feedbackSection = accordionDetails.querySelector('#teacher-feedback-section');
          if (feedbackSection) {
            feedbackSection.scrollIntoView({ 
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest'
            });
          } else {
            accordionDetails.scrollTo({
              top: accordionDetails.scrollHeight,
              behavior: 'smooth'
            });
          }
        }
      });
    }, 300);
  };

  const buttonText = useMemo(() => {
    if (isAssignmentTakable()) {
      if (submission?.complete && retakeAvailable) {
        return "Retake";
      }
      if (submission) {
        return "Resume";
      }
      if (isException) {
        return exceptionStatusText;
      }
      return "Start";
    }
    if (isException) {
      return exceptionStatusText;
    }
    if (submission?.complete && !submission.retaking) {
      return "completed";
    }
    return "Past due";
  }, [
    isAssignmentTakable,
    submission,
    retakeAvailable,
    isException,
    exceptionStatusText,
  ]);

  const AssignmentTitle = useMemo(() => {
    const displayName = data?.displayName || data?.data?.displayName;
    const shortName = BookSynoname[chapter];
    const shortN = data?.typeId === "quiz" ? "Q" : "A";
    let pg = numberMaskForNonAssignable
      ? nonAssignAbleMaskId?.maskId
      : getNumberMask(data?.data?.page || data?.assignment?.pageId || data?.pageId);
    pg = pg?.length > 20 ? data?.data?.bookId?.substring(0, 10) : `Pg.${pg ?? ""}`;
    return is_data_debate ? displayName : `${displayName} (${shortName ?? shortN}|${pg || ""})`;
  }, [
    data,
    chapter,
    is_data_debate,
    numberMaskForNonAssignable,
    nonAssignAbleMaskId,
    getNumberMask,
  ]);

  const pageCover = usePageCover({ assignmentData: data?.data });

  const coverImageSrc = useMemo(() => {
    const src = isVideo(get(data, "data.chapter"), resources)
      ? imageFetchFromPodcast(get(data, "data.page"), resources)
      : imageFetch(booksAllList, chapter, get(data, "data.page"));
    const cover_img_ext = getCoverForAssignment(data);
    return pageCover || cover_img_ext || src;
  }, [data, resources, booksAllList, chapter, pageCover]);

  const resourceLabel = useMemo(() => {
    const dataResource = find(resourcesVideos, { id: data?.data?.page });
    return dataResource?.resource;
  }, [resourcesVideos, data?.data?.page]);

  const lastPastSubmissionNumber = useMemo(() => {
    if (!pastSubmissions?.length) {
      return 0;
    }
    return pastSubmissions.reduce(
      (max, pt) => Math.max(max, parseInt(pt.submissions, 10) || 0),
      0
    );
  }, [pastSubmissions]);

  const getCompleteInclompleteMark = (isComplete)=>{
      if(isComplete){
        return <Check style={{ color: COLOR.green100, fontSize: 18 }} />
      } else{
        return <Close style={{ color: COLOR.red, fontSize: 18 }} />
      }
}

const getGrade = () => {
  if (!submission || !submission.id) return '-';
  if (submission.retaking && !submission.complete) {
      return "-";
  }
  const grade = submission?.grade >= 0 ? submission.grade : '';
  let bg_text 
  if (currentUser?.role === 'student') {
    bg_text = 'TBG';
  } else {
    bg_text = submission&&submission.ai_grade&&submission.ai_grade?.length > 0?"TBG - AI": "TBG";
  }
  const face_grade = submission?.face_grade;
  const isTbg = submission?.manualGrading && checkIsManualGradable((get(submission, "assignment.questions")));
  if(submission?.assignmentType === "bingo" && ungraded){
    const isSubmitted = submission?.answers?.length > 0 ? submission?.answers?.some((el)=> el?.is_submitted):false;
    return isSubmitted ? 'Credit' : '-';
  }
  if (ungraded) return 'Credit';
  if (isCompleteInComplete && (has(submission, "id") || !isAssignmentTakable())) {
      return getCompleteInclompleteMark(submission?.grade > 0);
  }
  return subMissionViewTBG({isPointSystem, isTbg, face_grade, bg_text, max_point, grade});
};
  const handleChangeExpend = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : null);
  };
  const getGradePastSubmissions = (pt) => {
    const grade = pt?.grade>0||pt?.grade==0?pt?.grade:0;
    if(pt?.assignmentType === "bingo" && ungraded){
      const isSubmitted = pt?.answers?.length > 0 ? pt?.answers?.some((el)=> el?.is_submitted):false;
      return isSubmitted ? 'Credit' : '-';
    }
    if (ungraded) return 'Credit'
    if (isCompleteInComplete) {
      return grade > 0 ? 'Completed' : 'In completed';
    } else if (isPointSystem) {
      if (grade > 0 && max_point > 0) {
        return `${Math.round((grade / 100) * max_point)}/${max_point}`
      } else {
        return `0/${max_point}`;
      }

    }
    return `Grade -${grade}`;

  }
  const pastSubmissionView = useCallback(() => {
    if (pastSubmissions && pastSubmissions.length > 0) {
      return (
        <div>
          {map(pastSubmissions, pt => (
            <Accordion
              square
              expanded={expanded === pt.id}
              onChange={handleChangeExpend(pt.id)}
              className={`accordianTitleCstm ${expanded === pt.id ? 'active' : ''}`}
            >
              <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                <AccordianTitle className="acordionTitleUpr">
                  <span>{"Submission-" + pt.submissions} {getGradePastSubmissions(pt)} {isGradedByTeacher(pt,true)}</span>
                  <div className="seeTeacherFeed">
                  {expanded === pt.id && (
                    <FeedbackLink 
                      disabled={!(get(pt, "feedback") || get(pt, "audioFeedback"))}
                      onClick={(e) => scrollToTeacherFeedback(e, !!(get(pt, "feedback") || get(pt, "audioFeedback")))}>
                      See teacher feedback
                    </FeedbackLink>
                  )}
                  <Rotate open={expanded === pt.id}><ArrowRight /></Rotate>
                  {/* <label className="accordiaAssigClos" onClick={() => setResponsesModalOpen(false)}>
                    <img src={closeIconSvg} alt="" />
                   </label> */}
                  </div>  
                </AccordianTitle>
              </AccordionSummary>

              <AccordionDetails>
                <GradeDisplay
                  key={get(pt, "id")}
                  answers={get(pt, "answers")}
                  feedback={get(pt, "feedback")}
                  ai_feedback={get(pt, "ai_feedback")}
                  ai_suggestion={get(pt, "ai_suggestion")}
                  audioFeedback={get(pt, "audioFeedback")}
                  grade={get(pt, "grade")}
                  name={get(submission, "displayName", get(submission, "assignment.displayName"))}
                  questions={get(submission, "assignment.questions", [])}
                  type={"past due"}
                  isLate={pt.islate}
                  isExpended
                  assignment={pt}
                  hasFeedback={true &&(get(pt, "feedback")|| get(pt, "audioFeedback"))}
                  activity={data}
                />
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      );
    } else {
      return null;
    }
  }, [pastSubmissions, expanded]);

  const CurrentSubmissionView = useCallback(() => {
    if (
      !(
        ((is_worksheet || is_data_worksheet) && submission?.id) ||
        get(submission, "submissions") != 0 ||
        get(submission, "graded") ||
        get(submission, "answers.length") > 0
      )
    ) {
      return null;
    }
      const CurrentSub = lastPastSubmissionNumber + 1;
      let Title = "";
      if (CurrentSub === 1) {
        Title = CurrentSub;
      } else {
        Title = CurrentSub + ' (Last Submission)';
      }
      const status = getGrade();
      const is_inprogress = status === 'in progress';
      return (
        <div className="accordiaAssignment">
          <Accordion
            square
            expanded={expanded}
            onChange={handleChangeExpend(get(submission, "id"))}
            className={`accordianTitleCstm ${expanded ? 'active' : ''}`}
          >
            
            <AccordionSummary style={CurrentSubmission} aria-controls="panel1d-content" id="panel1d-header" className="assignAccordian">
              <AccordianTitle className="acordionTitleUpr">
              <span>{"Submission-" + Title}  {` Grade - ${get(submission, "exceptionStatus") > 0 ? getStatusByCode(get(submission, "exceptionStatus"),currentUser) : status}`} {isGradedByTeacher(submission)}</span> <Rotate open={expanded === 'current'}></Rotate>
                  
                 <div className="seeTeacherFeed">
                  {expanded === 'current' && (
                    <FeedbackLink 
                      disabled={!(get(submission, "feedback") || get(submission, "audioFeedback"))}
                      onClick={(e) => scrollToTeacherFeedback(e, !!(get(submission, "feedback") || get(submission, "audioFeedback")))}>
                      See teacher feedback
                    </FeedbackLink>
                  )}
                  <Rotate open={expanded}><ArrowRight /></Rotate>
                  </div>

                </AccordianTitle>
               {/* <label className="accordiaAssigClos" onClick={() => setResponsesModalOpen(false)}>
                 <img src={closeIconSvg} alt="" /> 
               </label> */}
            </AccordionSummary>

            <AccordionDetails>
              {is_inprogress ? <Notification>The assignment process is currently in progress.</Notification> : null}
              {currentUser?.role === "student" && is_inprogress ? null : (
                <GradeDisplay
                  key={get(submission, "id")}
                  answers={get(submission, "answers")}
                  feedback={get(submission, "feedback")}
                  ai_feedback={get(submission, "ai_feedback")}
                  ai_suggestion={get(submission, "ai_suggestion")}
                  audioFeedback={get(submission, "audioFeedback")}
                  grade={get(submission, "exceptionStatus") > 0 ? getStatusByCode(get(submission, "exceptionStatus"),currentUser) : getGrade()}
                  name={get(submission, "displayName", get(submission, "assignment.displayName"))}
                  questions={is_worksheet || is_data_worksheet ? questions : get(submission, "assignment.questions", [])}
                  selected_student_id={submission?.userId}
                  type={"current due"}
                  is_game={is_game}
                  is_debate={is_data_debate || is_debate}
                  is_worksheet={is_data_worksheet || is_worksheet}
                  is_loteria={is_data_loteria || is_loteria}
                  isLate={get(submission, "isLate")}
                  isExpended
                  assignment={submission}
                  activity={data}
                />
              )}
            </AccordionDetails>
          </Accordion>
        </div>
      );
  }, [pastSubmissions, expanded, questions, lastPastSubmissionNumber, submission, currentUser, is_worksheet, is_game, is_data_debate, is_debate, is_data_worksheet, is_data_loteria, is_loteria, data]);

  const handleCloseResponsesModal = useCallback(() => {
    setResponsesModalOpen(false);
  }, []);

  const handleOpenResponsesModal = useCallback(() => {
    if (!canViewResponses) return;
    setResponsesModalOpen(true);
    onShowResponce();
  }, [onShowResponce, canViewResponses]);

  if ((!data.data || !chapter || !Object.keys(data.data ?? {}).length > 0) && !is_data_debate && !is_data_loteria)
    return null;

  const isWaitingForAiGrading = () => {
    const is_waiting = isWaitingForAiGradingRestriction(submission,assignment,isAiPermissionEnabled);
    if (is_waiting) {
      showAlert('Please wait while the AI processes your grading.', 'warning');
      return true;
    }
    return false;
  };
  const checkRetake = () => {
    if(isWaitingForAiGrading()) return;
    if (buttonText === "Retake") {
      setisRetakeOpen(true)
    } else {
      onSubmit()
    }
  }

  return (
    <SentryWrap>
    <OuterWrapper>
      <SpinLoader dataloader={loadingQuestions} />
      <Wrapper>
      <MicrophonePermissionModal grantedAllow={reditrectToAssignment} />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={openReviewDialog}
          autoHideDuration={3000}
          onClose={handleClose}>
          <Alert onClose={handleClose} severity="error">
            <strong>ALERT:</strong> Only for Review!
          </Alert>
        </Snackbar>

        <RetakeModal isRetakeOpen={isRetakeOpen} onClose={() => setisRetakeOpen(false)} onSubmit={onSubmit} />
                
        <ImageContiner onClick={() => setModalState(true)} className="semesterBookCvr">
          <Image src={coverImageSrc} alt="" title="" className="imageCover" />
          {coverTitle ? <label className="semesterBookTitle">{coverTitle}</label> : null}
        </ImageContiner>

        <Container>     
          
            <Header>
                <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                  <Tooltip placement="bottom" title={AssignmentTitle}>
                    {AssignmentTitle}
                  </Tooltip>
                  {!isNaN(parseInt(data?.timeDuration)) && data?.timeDuration > 0 && (
                    <WatchLater style={{ fontSize: "15px", marginLeft: "6px" }} />
                  )}
                </div>
                <ExamHeader>
                  {
                    data?.data?.is_exam && (
                      <ExamBadge color="#0f2c70" textColor="#fff">
                        Examen
                      </ExamBadge>
                    )
                  }
                  {
                    data?.data?.is_unit_exam && (
                      <ExamBadge color="#cae3e3" textColor="#000">
                        Unit Exam
                      </ExamBadge>
                    )
                  }
                </ExamHeader>
            </Header>
          
      
          <TextContainer>
            {!is_data_debate && (
              <>
                {isVideo(chapter, resources) ? (<Text className="ebookInfo"><span>Resource:</span><strong style={{ color: COLOR.green300, fontWeight: 600 }}>{resourceLabel}</strong></Text>
                ) : (<Text className="ebookInfo"><span>Book:</span><strong>{book?.description} </strong>{" "}</Text>)}
              </>
            )}
            {!is_data_debate && (
              <>
                {isVideo(chapter, resources) ? null : <Text className="ebookInfo"><span>Page:</span>
                  <strong>
                    {numberMaskForNonAssignable ? nonAssignAbleMaskId?.maskId : isStoryBook ? "story" : numberMasked}
                    {/* {getNumberMask(data?.data ? data.data.page : data.page)} */}
                  </strong>{" "}
                  {!data?.dueDate && (
                    <strong
                      style={{ marginLeft: "8px", textDecoration: "underline" }}
                    >
                      {structureFetch(booksAllList, chapter, data?.page)}
                    </strong>
                  )}
                </Text>}
              </>
            )}
            {data?.scheduleAt && (
              <Text className="ebookInfo">
                <span>Start Date:{" "}</span>
                <strong>
                  {moment(get(data, "scheduleAt")).format('MMM DD, YYYY hh:mm A')}
                </strong>
              </Text>
            )}
            {/* {!is_data_debate && !is_data_loteria && data?.dueDate && (
              <Text className="ebookInfo">
                <span>Due Date:</span>
                <strong> */}
            {!is_game && !is_data_debate && !is_data_loteria && data?.dueDate && (
              <Text className="ebookInfo">
                <span>Due Date:</span>
                <strong style={{ color: COLOR.green300, fontWeight: 600 }}>
                  {moment(get(data, "dueDate")).format('MMM DD, YYYY hh:mm A')}
                </strong>
              </Text>
            )}

            {/* {!is_data_debate && data?.lateDate && !shouldSkipLateDateForDiffStudent(data, currentUser, currentClass) ? (
              <Text className="ebookInfo">
                <span>Late Submission:</span>
                <strong>
                  {get(data, "lateDate") == "always" ? "No limit" : moment(get(data, "lateDate")).format('MMM DD, YYYY hh:mm A')}
                </strong>
              </Text>
            ) : null} */}

            {showCountdownTimer && currentUser?.role === 'student' && (get(data, "dueDate") || (get(data, "lateDate") && !shouldSkipLateDateForDiffStudent(data, currentUser, currentClass))) && (
              <Text className="ebookInfo" style={{display: 'flex'}}>
                <span>Time left to submit:</span>
                <strong>
                  <CountdownTimer 
                    dueDate={get(data, "dueDate")} 
                    lateDate={shouldSkipLateDateForDiffStudent(data, currentUser, currentClass) ? null : get(data, "lateDate")}
                    onTimeUp={() => {
                      setShowCountdownTimer(false);
                      setTimerExpired(true);
                      if (data?.id) {
                        localStorage.removeItem(`finishLater_${data.id}`);
                      }
                    }}
                  />
                </strong>
              </Text>
            )}
            {!is_data_debate && data?.retakes && (
              <Text className="ebookInfo">
                <span>Retakes Allowed:</span>
                <strong>
                  {data?.retakes}
                </strong>
              </Text>
            )}
            {!is_data_debate && !isNaN(parseInt(data?.timeDuration)) && data?.timeDuration > 0 && (
              <Text className="ebookInfo">
                <span>Duration in minutes:</span>
                <strong>
                  {data?.timeDuration}
                </strong>
              </Text>
            )}
            {view_result ? <Text className="ebookInfo">
              <span>Grade:</span>
              <strong style={{ color: COLOR.green300, fontWeight: 600 }}>
                <StatusBadge status={ungraded && submission ? "Credit" : submission?.exceptionStatus > 0 ? getStatusByCode(submission?.exceptionStatus, currentUser) : getGrade()} />
              </strong>
            </Text> : null}

             {!view_result?<NoteMark note={"Grade and feedback will be show upon the teacher approval"} />:null}
             
            {is_game ? <Text className="ebookInfo">
              Type:{" "}
              <strong style={{ color: COLOR.green300, fontWeight: 600 }}>
                Game
              </strong>
            </Text> : null}
            {is_data_debate || is_debate ? <Text className="ebookInfo">
              <span>Type:</span>
              <strong>
                Debate
              </strong>
            </Text> : null}
            {is_data_worksheet || is_worksheet ? <Text className="ebookInfo">
              <span>Type:</span>
              <strong>
                Grammar drill
              </strong>
            </Text> : null}
            {is_data_loteria ? <Text className="ebookInfo">
              <span>Type:</span>
              <strong>
                Loteria
              </strong>
            </Text> : null}
            {!data?.dueDate && (
              <Text className="ebookInfo">
                <span>Status:</span>{" "}<strong>Unassigned</strong>
              </Text>
          )}
          <div className="ebookStatus 123">
           {data?.dueDate && !is_data_loteria && (
            <Actions>
              <>
                {!get(submission, "complete") && (!isAssignmentTakable() || timerExpired) ? (
                  <CompleteText>Past Due</CompleteText>
                ) : (
                  <>
                    {get(submission, "complete") && (!retakeAvailable || (isBeforTime(get(data, "dueDate"), servertime, timezone) && isBeforTime(get(data, "lateDate", get(data, "dueDate")), servertime, timezone)))
                      ? (
                        <CompleteText className="ebookStatusSpan" deactivate={!isActive || deactivateStudent}>
                          {isActive ? <img src={rightTickSvg} alt="" /> : null}
                          {!isActive || deactivateStudent ? "Deactivated" : "Completed"}
                        </CompleteText>
                      ) : (
                        <TootipWrapper
                          hasToolTip={hasDuration || !isActive || deactivateStudent}
                          label={!isActive || deactivateStudent? "Assignment is deactivated by teacher" : submission ? `This activity includes a "timer", are you sure you want to resume it?` : null
                          }
                        >
                          <div className="rightComplete">
                          {/* <img src={rightTickSvg} alt="" /> */}
                          <Button
                            color={!isActive || deactivateStudent ? "secondary" : "primary"}
                            onClick={checkRetake}
                            disabled={!isAssignmentTakable() || currentUser?.role === 'parent'}
                            variant="contained"
                            style={{ marginBottom: "4px" }}
                          >
                            <StatusBadge status={!isActive || deactivateStudent ? "Deactivated" : buttonText} />
                            {hasDuration && (
                              <WatchLater
                                style={{ fontSize: "15px", marginLeft: "6px" }}
                              />
                            )}
                          </Button>
                         </div> 
                        </TootipWrapper>
                      )}
                  </>
                )}
              </>
            </Actions>
          )}
          {data?.dueDate &&
            typeof submission == "object" &&
            Object.keys(submission).length > 0 && view_result && (
              <Responce
                disabled={!canViewResponses}
                onClick={handleOpenResponsesModal}
              >
                View responses
              </Responce>
            )}
          </div>  
          </TextContainer>
        </Container> 
      </Wrapper>

      {/* Start of Ebook Image Modal */}
        <Modal       
          open={modalOpen}
          onClose={() => setModalState(false)}
          style={{ height: "100%", width: "100%" }}>
            <ImageModal>
              <div className="mdlBookTitleCstmUpr">  
               <Image src={coverImageSrc} alt="" title="" className="imageCover" />
               {coverTitle ? <label className="mdlBookTitleCstm">{coverTitle}</label> : null}
             </div>  
            </ImageModal>
        </Modal>
      {/* End of Ebook Image Modal */}

      {/* Start of Accordian Modal code */}
      {responsesModalOpen && (
        <Modal disableScrollLock={false} open={responsesModalOpen} onClose={handleCloseResponsesModal} className="accordianModal">
          <div className="ResponceContainerModal">
              <label className="accordiaAssigClos" onClick={handleCloseResponsesModal}>
                <img src={closeIconSvg} alt="" />
              </label>
              {pastSubmissionView()}
              {CurrentSubmissionView()}
           </div>
        </Modal>
      )}
      {/* End of Accordian Modal code */}

    </OuterWrapper>
   </SentryWrap>
  );
};


const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
});

const areAssignmentStatusPropsEqual = (prev, next) =>
  prev.chapter === next.chapter &&
  prev.data === next.data &&
  prev.submission === next.submission &&
  prev.booksAllList === next.booksAllList &&
  prev.showResponce === next.showResponce &&
  prev.book === next.book &&
  prev.assignment === next.assignment &&
  prev.currentUser?.id === next.currentUser?.id;

export default connect(mapStateToProps, null)(
  memo(AssignmentStatus, areAssignmentStatusPropsEqual)
);
